import VOPSTeamAssessment from './VOPSTeamAssessment';

export default VOPSTeamAssessment;
